import { createFileRoute } from '@tanstack/react-router';
import { validateComposerSearch } from './-composer-search';
import { ComposerActionRoute } from './-route-wrappers';

/**
 * The action composer's own URL. No `appBundle` on its resolver: this URL has
 * no `journeys` segment for the resolver's bundle-aware branch to rebuild the
 * target from. The resolver runs inside the flag branch, in
 * `ComposerActionRoute`.
 */
function ComposerActionUrlRoute() {
  const { actionId } = Route.useParams();

  return <ComposerActionRoute actionId={actionId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/composer/actions/$actionId')({
  component: ComposerActionUrlRoute,
  validateSearch: validateComposerSearch,
});
